// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Loaded, Loadable, ScopeCategory, ScopeConstraint, LoadingStatus } from '@app/core';
import { ScopesActionsUnion, ScopesActionTypes } from './role-scope.actions';

export interface ScopesState {
  scopeCategories?: Loaded<ScopeCategory[]> | Loadable;
  scopeConstraints: {
    [categoryId: string]: Loaded<ScopeConstraint[]> | Loadable;
  };
}

export function scopesReducer(
  state: Readonly<ScopesState> = { scopeConstraints: {} },
  action: ScopesActionsUnion
): Readonly<ScopesState> {
  switch (action.type) {
    case ScopesActionTypes.SCOPE_CATEGORIES_LOADING:
      return {
        ...state,
        scopeCategories: {
          status: LoadingStatus.LOADING
        }
      };

    case ScopesActionTypes.SCOPE_CATEGORIES_LOAD_COMPLETE:
      return {
        ...state,
        scopeCategories: {
          data: action.payload,
          status: LoadingStatus.LOAD_COMPLETE
        }
      };

    case ScopesActionTypes.SCOPE_CATEGORIES_LOAD_FAILED:
      return {
        ...state,
        scopeCategories: {
          status: LoadingStatus.LOAD_FAILED
        }
      };

    case ScopesActionTypes.SCOPE_CONSTRAINTS_LOADING:
      return {
        ...state,
        scopeConstraints: {
          ...(state.scopeConstraints || {}),
          [action.payload]: {
            status: LoadingStatus.LOADING
          }
        }
      };

    case ScopesActionTypes.SCOPE_CONSTRAINTS_LOAD_COMPLETE:
      return {
        ...state,
        scopeConstraints: {
          ...(state.scopeConstraints || {}),
          [action.payload.categoryId]: {
            data: action.payload.constraints,
            status: LoadingStatus.LOAD_COMPLETE
          }
        }
      };

    case ScopesActionTypes.SCOPE_CONSTRAINTS_LOAD_FAILED:
      return {
        ...state,
        scopeConstraints: {
          ...(state.scopeConstraints || {}),
          [action.payload]: {
            status: LoadingStatus.LOAD_FAILED
          }
        }
      };
  }
  return state;
}

export function getScopeCategories(state: ScopesState) {
  return state.scopeCategories;
}

export function getScopeConstraints(categoryId: string): (state: ScopesState) => Loadable | undefined {
  return (state: ScopesState) => {
    return state.scopeConstraints[categoryId];
  };
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scope.reducer.ts